import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import './Modals.css';

const SuccessModal = ({ isOpen, onClose, title, message }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header success-header">
          <h3><i className="fas fa-check-circle"></i> {title}</h3>
          <button onClick={onClose} className="close-btn">&times;</button>
        </div>
        <div className="admin-modal-body">
          <p>{message}</p>
        </div>
        
        {/* DÜZELTME: 'div' kaldırıldı ve butonun sınıfı 'confirm' olarak değiştirildi */}
        <div className="admin-modal-footer">
            <button onClick={onClose} className="modal-btn confirm">
                {t('ok', 'Tamam')}
            </button>
        </div>

      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default SuccessModal;